import { api } from "api";

/** Driver shifts (api#198). Every endpoint is admin only; a city admin stays in their city. */

export const getDriverShiftWeek = async ({ cityId, start }) => {
    const response = await api.get("api/driver-shifts/week", { params: { cityId, start } });
    return response.data;
};

export const createShiftTemplate = async (data) => {
    const response = await api.post("api/driver-shift-templates", data);
    return response.data;
};

export const updateShiftTemplate = async ({ id, ...data }) => {
    const response = await api.patch(`api/driver-shift-templates/${id}`, data);
    return response.data;
};

export const setShiftSeats = async ({ templateId, date, seats }) => {
    const response = await api.put(`api/driver-shift-templates/${templateId}/seats/${date}`, {
        seats,
    });
    return response.data;
};

export const assignDriverShift = async (data) => {
    const response = await api.post("api/driver-shifts", data);
    return response.data;
};

export const updateDriverShift = async ({ id, ...data }) => {
    const response = await api.patch(`api/driver-shifts/${id}`, data);
    return response.data;
};

export const updateCityDriverShifts = async ({ cityId, ...data }) => {
    const response = await api.patch(`api/city/${cityId}/driver-shifts`, data);
    return response.data;
};
